// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import MainContents from 'components/templates/MainContents'
import { type ReservationType } from 'types/reservation'
import Button from 'components/atoms/Button'
import HeadlineReservation from 'components/molecules/HeadlineReservation'

export type PropTypes = {
  contactInformationList: Array<{
    title: string,
    detail: string,
  }>,
}

export default props => (
  <MainContents>
    <HeadlineReservation
      title={i18n.t('page.dashboard.reservation.checkInput')}
    >
      {i18n.t('page.dashboard.reservation.examinationToPaidDesc1')}
      <br />
      {i18n.t('page.dashboard.reservation.examinationToPaidDesc2')}
    </HeadlineReservation>
    <FormList>
      <FormBlock>
        <Title>
          {i18n.t('page.dashboard.reservation.contactInformationTitle')}
        </Title>
        <dl>
          {props.contactInformationList.map(({ title, detail }, index) => (
            <FormBlockItem key={index}>
              <FormBlockItemHead>{title}</FormBlockItemHead>
              <FormBlockItemDetail>{detail}</FormBlockItemDetail>
            </FormBlockItem>
          ))}
        </dl>
      </FormBlock>
      <FormBlock>
        <Title>{i18n.t('page.shared.l_00063')}</Title>
        <dl>
          {props.companyInformationList.map(({ title, detail }, index) => (
            <FormBlockItem key={index}>
              <FormBlockItemHead>{title}</FormBlockItemHead>
              <FormBlockItemDetail>{detail}</FormBlockItemDetail>
            </FormBlockItem>
          ))}
        </dl>
      </FormBlock>
    </FormList>
    <ButtonList>
      <ButtonWrap>
        <Button
          buttonType="huge"
          colorType="gray"
          tag="button"
          fontSizePc="{16}"
          fullWidthSp
          onClick={props.onClickCancel}
        >
          {i18n.t('page.dashboard.reservation.toCorrect')}
        </Button>
      </ButtonWrap>
      <ButtonWrap>
        <Button
          buttonType="huge"
          colorType="blue"
          tag="button"
          fontSizePc="{16}"
          fullWidthSp
          onClick={props.onClickPayExamination}
        >
          {i18n.t('page.dashboard.reservation.examinationApply')}
        </Button>
      </ButtonWrap>
    </ButtonList>
  </MainContents>
)

const FormList = styled.div`
  margin-top: ${spacing.large}px;
`
const Title = styled.h2`
  font-size: ${fontSize.medium}px;
  font-weight: bold;
  padding-bottom: ${spacing.small_3}px;
  border-bottom: 1px solid ${Colors.grayE};
  ${mediaMin.phone`	
    font-size: ${fontSize.medium_2}px;
    font-weight: normal;
    padding-bottom: 18px;
  `};
`
const FormBlock = styled.div`
  &:not(:first-child) {
    margin-top: ${spacing.large}px;
    ${mediaMin.phone`	
      margin-top: ${spacing.huge}px;
    `};
  }
`
const FormBlockItem = styled.div`
  margin-top: ${spacing.medium}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.medium_2}px;
    display: flex;
  `};
`
const FormBlockItemHead = styled.dt`
  font-weight: bold;
  font-size: ${fontSize.small_2}px;
  ${mediaMin.phone`	
    font-size: ${fontSize.small_3}px;
    width: 180px;
    flex-shrink: 0;
  `};
`
const FormBlockItemDetail = styled.dd`
  margin-top: ${spacing.small_2}px;
  ${mediaMin.phone`	
    margin-top: 0;
  `};
`
const ButtonList = styled.div`
  display: flex;
  margin-top: ${spacing.large}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.huge}px;
  `};
`
const ButtonWrap = styled.div`
  width: 100%;
  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }
`



// WEBPACK FOOTER //
// ./src/components/pages/ReservationPayExaminationConfirmPage/index.jsx